<section class="product-details">
	@if (product) {
		<div
			class="product-details-content"
			fxLayout="column"
			fxLayout.gt-xs="row"
			fxLayoutGap="0px"
			fxLayoutGap.gt-xs="30px"
			fxLayoutGap.gt-sm="116px"
		>
			<!-- Left side -->
			<div class="left-container" fxFlex="100%" fxFlex.gt-xs="40%">
				<g-product-media-viewer [items]="(mediaItems$ | async) || []" />
				@if (viewport.isNotExtraSmall$ | async) {
					<g-product-additional-info [product]="product" />
				}
			</div>

			<!-- Right side -->
			<div class="right-container" fxFlex="100" fxFlex.gt-xs="60%">
				<div class="category-breadcrumb">
					@if (category) {
						<a [routerLink]="['/category', category.id, category.slug]">{{
							category.locale.name | getText
						}}</a>
					}
					<g-icon [icon]="icons.faAngleRight" />
					<a
						[routerLink]="['/product', product.id, product.slug]"
						[attr.title]="product.locale.product_name | getText"
						>{{ product.locale.product_name | getText }}</a
					>
				</div>

				<h1>
					<span class="product-name" data-cy="productName">{{
						product.locale.product_name | getText
					}}</span>
					@if (!product.is_published) {
						<span class="unpublished-label" i18n="@@ProductDetailsUnpublished">Unpublished</span>
					}
				</h1>

				@if (viewport.isNotExtraSmall$ | async) {
					<mat-tab-group dynamicHeight>
						@if (product.locale.product_description) {
							<mat-tab label="Description" i18n-label="@@ProductDetailsDescription">
								<div
									class="description-container"
									[ngClass]="{
										'is-expandable': (product.locale.product_description | localizedLength) > 600,
										'is-expanded': isDescriptionExpanded,
									}"
								>
									<div [innerHTML]="product.locale.product_description | getText"></div>
								</div>
								@if ((product.locale.product_description | localizedLength) > 600) {
									<div class="expand-link-container">
										<a
											(click)="isDescriptionExpanded = !isDescriptionExpanded"
											(keydown)="isDescriptionExpanded = !isDescriptionExpanded"
											tabindex="0"
										>
											@if (isDescriptionExpanded) {
												<span i18n="@@ProductDetailsShowLess">Show less</span>
											} @else {
												<span i18n="@@ProductDetailsShowMore">Show more</span>
											}
										</a>
									</div>
								}
							</mat-tab>
						}

						@if (product.locale.technical_description) {
							<mat-tab label="Technical Information" i18n-label="@@ProductDetailsTechnicalInformation">
								<div
									class="description-container"
									[ngClass]="{
										'is-expandable': (product.locale.technical_description | localizedLength) > 600,
										'is-expanded': isTechnicalDescriptionExpanded,
									}"
								>
									<div [innerHTML]="product.locale.technical_description | getText"></div>
								</div>
								@if ((product.locale.technical_description | localizedLength) > 600) {
									<div class="expand-link-container">
										<a
											(click)="isTechnicalDescriptionExpanded = !isTechnicalDescriptionExpanded"
											(keydown)="isTechnicalDescriptionExpanded = !isTechnicalDescriptionExpanded"
											tabindex="0"
										>
											@if (isTechnicalDescriptionExpanded) {
												<span i18n="@@ProductDetailsShowLess">Show less</span>
											} @else {
												<span i18n="@@ProductDetailsShowMore">Show more</span>
											}
										</a>
									</div>
								}
							</mat-tab>
						}

						@if (showInternalInfo && product.locale.internal_information) {
							<mat-tab label="Internal" i18n-label="@@ProductDetailsInternalInformation">
								<div
									class="description-container"
									[ngClass]="{
										'is-expandable': (product.locale.internal_information | localizedLength) > 550,
										'is-expanded': isInternalInfoExpanded,
									}"
									[innerHTML]="product.locale.internal_information | getText"
								></div>
								@if ((product.locale.internal_information | localizedLength) > 550) {
									<div class="expand-link-container">
										<a
											(click)="isInternalInfoExpanded = !isInternalInfoExpanded"
											(keydown)="isInternalInfoExpanded = !isInternalInfoExpanded"
											tabindex="0"
										>
											@if (isInternalInfoExpanded) {
												<span i18n="@@ProductDetailsShowLess">Show less</span>
											} @else {
												<span i18n="@@ProductDetailsShowMore">Show more</span>
											}
										</a>
									</div>
								}
							</mat-tab>
						}
					</mat-tab-group>
				}

				<div class="product-info">
					@if (product.properties?.storageInfo?.isStockLevelVisible) {
						<div>
							@if (isInStock) {
								<div class="is-in-stock">
									<span i18n="@@ProductDetailsInStock">In stock</span>:
									<span>{{ product.stock_level || '0' }} {{ product.metadata.unit | getText }}</span>
								</div>
							} @else {
								<div class="is-out-of-stock">
									<span i18n="@@ProductDetailsOutOfStock">Out of stock</span>
								</div>
							}
						</div>
					}
					@if (product.sku) {
						<div data-cy="productSku"><span i18n="@@ProductDetailsSku">ID</span>: {{ product.sku }}</div>
					}
					@for (printfileDownloadUrl of printfileDownloadUrls; track $index) {
						<div data-cy="product-printfile-download-links" class="printfile-download-container">
							<a fxLayout="row" [attr.href]="printfileDownloadUrl" target="_blank">
								<g-icon fxFlex="16px" [icon]="icons.faDownload" />
								<span fxFlex="auto" i18n="@@ProductDetailsDownloadPrintfile">Download PDF</span>
							</a>
						</div>
					}
				</div>

				@if (viewport.isNotExtraSmall$ | async) {
					<div>
						@if (hasSelectableOptions && !isFormProduct) {
							<div>
								@if (isVariableProduct) {
									<div class="work-title-container">
										<label class="is-required" i18n="@@ProductDetailsWorkTitle" for="work-title"
											>Work title</label
										>
										<div class="form-group">
											<input
												id="work-title"
												maxlength="255"
												trim="blur"
												type="text"
												class="form-control work-title"
												[(ngModel)]="productEditor.workTitle"
												(focusout)="productEditor.setDefaultWorkTitle()"
												gAutofocus
											/>
											<div
												[hidden]="productEditor.workTitle?.length ?? 0 < 255"
												class="alert alert-danger"
											>
												<span i18n="@@ProductDetailsWorkTitleMaxLengthError"
													>Maximum length for work title is 255 characters</span
												>
											</div>
										</div>
									</div>
								}

								<div class="product-options-container">
									@if (product) {
										<g-product-option-selector
											[product]="product"
											[initialOptions]="productEditor.initialOptions"
											[setToBottom]="['quantity', 'order_quantity']"
											(selectedOptionsChanged)="optionsChanged($event)"
										/>
									}
								</div>
							</div>
						}

						@if (showProductPrice()) {
							<g-product-price
								[price]="productEditor.price$ | async"
								[isVariableProduct]="isVariableProduct"
							/>
						}
					</div>
				} @else {
					<!-- Mobile options & accordion & help -->
					<div class="mobile-content">
						@if (isVariableProduct) {
							<div class="work-title-container">
								<label class="is-required" i18n="@@ProductDetailsWorkTitle" for="work-title"
									>Work title</label
								>
								<div class="form-group">
									<input
										id="work-title"
										trim="blur"
										type="text"
										class="form-control work-title"
										[(ngModel)]="productEditor.workTitle"
										(focusout)="productEditor.setDefaultWorkTitle()"
										gAutofocus
									/>
								</div>
							</div>
						}

						@if (hasSelectableOptions && !isFormProduct) {
							<div class="product-options-container">
								@if (product) {
									<g-product-option-selector
										[product]="product"
										[initialOptions]="productEditor.initialOptions"
										[setToBottom]="['quantity', 'order_quantity']"
										(selectedOptionsChanged)="optionsChanged($event)"
									/>
								}
							</div>
						}
						@if (showProductPrice()) {
							<g-product-price
								[price]="productEditor.price$ | async"
								[isVariableProduct]="isVariableProduct"
							/>
						}
						<mat-accordion>
							@if (product.locale.product_description) {
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<mat-panel-title i18n="@@ProductDetailsDescription">Description</mat-panel-title>
									</mat-expansion-panel-header>
									<div class="card">
										<div
											class="mobile-text-content"
											[innerHTML]="product.locale.product_description | getText"
										></div>
									</div>
								</mat-expansion-panel>
							}

							@if (product.locale.technical_description) {
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<mat-panel-title i18n="@@ProductDetailsTechnicalInformation">
											Technical Information
										</mat-panel-title>
									</mat-expansion-panel-header>
									<div class="card">
										<div
											class="mobile-text-content"
											[innerHTML]="product.locale.technical_description | getText"
										></div>
									</div>
								</mat-expansion-panel>
							}
						</mat-accordion>
						<g-product-additional-info [product]="product" />
					</div>
				}
			</div>
		</div>
	}
</section>
